// FiltroFechaUI.jsx

import React from 'react';

const FiltroFechaUI = ({
    filtro, setFiltro,
    fechaSeleccionada, setFechaSeleccionada,
    horaSeleccionada, setHoraSeleccionada,
    semanaSeleccionada, setSemanaSeleccionada,
    mesSeleccionado, setMesSeleccionado,
    anioSeleccionado, setAnioSeleccionado,
    handleApplyFilter,
    maxAnio
}) => {
    return (
        <>
            {/* Controles de Filtro Principal */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center mb-3 gap-2 px-2">
                <span className="form-label mb-0 fw-semibold text-nowrap">
                    Filtro:
                </span>
                <div className="d-grid d-md-flex flex-wrap gap-2 w-100">
                    <div className="d-grid d-md-flex gap-2 mb-2 mb-md-0">
                        <button
                            className={`btn btn-sm mx-1 ${filtro === "dia" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setFiltro("dia")}>Día</button>
                        <button
                            className={`btn btn-sm mx-1 ${filtro === "dia-hora" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setFiltro("dia-hora")}>Hora</button>
                        <button
                            className={`btn btn-sm mx-1 ${filtro === "semana" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setFiltro("semana")}>Semana</button>
                        <button
                            className={`btn btn-sm mx-1 ${filtro === "mes" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setFiltro("mes")}>Mes</button>
                        <button
                            className={`btn btn-sm mx-1 ${filtro === "año" ? "btn-primary" : "btn-outline-primary"}`}
                            onClick={() => setFiltro("año")}>Año</button>
                    </div>
                </div>
            </div>

            {/* Selectores de Fecha/Tiempo */}
            {(filtro === "dia" || filtro === "dia-hora") && (
                <div className="row mb-3 gx-2 px-2 align-items-center">
                    <div className="col-12 col-md-auto">
                        <label htmlFor="fechaSelect" className="form-label mb-0 fw-semibold">Fecha:</label>
                    </div>
                    <div className="col-12 col-sm">
                        <input
                            type="date"
                            id="fechaSelect"
                            className="form-control form-control-sm"
                            style={{ width: "70%" }}
                            value={fechaSeleccionada}
                            onChange={(e) => setFechaSeleccionada(e.target.value)}
                        />
                    </div>
                    {filtro === "dia-hora" && (
                        <>
                            <div className="col-12 col-md-auto mt-2 mt-md-0">
                                <label htmlFor="horaSelect" className="form-label mb-0 fw-semibold">Hora:</label>
                            </div>
                            <div className="col-12 col-sm">
                                <input
                                    type="time"
                                    id="horaSelect"
                                    className="form-control form-control-sm"
                                    style={{ width: "50%" }}
                                    value={horaSeleccionada}
                                    onChange={(e) => setHoraSeleccionada(e.target.value)}
                                />
                            </div>
                        </>
                    )}
                </div>
            )}

            {filtro === "semana" && (
                <div className="row mb-3 gx-2 px-2 align-items-center">
                    <div className="col-12 col-md-auto">
                        <label htmlFor="semanaSelect" className="form-label mb-0 fw-semibold">Semana:</label>
                    </div>
                    <div className="col-12 col-sm">
                        <input
                            type="week"
                            id="semanaSelect"
                            className="form-control form-control-sm"
                            style={{ width: "60%" }}
                            value={semanaSeleccionada}
                            onChange={(e) => setSemanaSeleccionada(e.target.value)}
                        />
                    </div>
                </div>
            )}

            {filtro === "mes" && (
                <div className="row mb-3 gx-2 px-2 align-items-center">
                    <div className="col-12 col-md-auto">
                        <label htmlFor="mesSelect" className="form-label mb-0 fw-semibold">Mes:</label>
                    </div>
                    <div className="col-12 col-sm">
                        <input
                            type="month"
                            id="mesSelect"
                            className="form-control form-control-sm"
                            style={{ width: "60%" }}
                            value={mesSeleccionado}
                            onChange={(e) => setMesSeleccionado(e.target.value)}
                        />
                    </div>
                </div>
            )}

            {filtro === "año" && (
                <div className="row mb-3 gx-2 px-2 align-items-center">
                    <div className="col-12 col-md-auto">
                        <label htmlFor="anioSelect" className="form-label mb-0 fw-semibold">Año:</label>
                    </div>
                    <div className="col-12 col-sm">
                        <input
                            type="number"
                            id="anioSelect"
                            className="form-control form-control-sm"
                            style={{ width: "50%" }}
                            min="2000"
                            max={maxAnio}
                            value={anioSeleccionado}
                            onChange={(e) => setAnioSeleccionado(e.target.value)}
                        />
                    </div>
                </div>
            )}

            {/* Botón Aplicar */}
            <div className="d-grid mb-3 px-2">
                <button
                    className="btn btn-primary btn-sm"
                    onClick={handleApplyFilter}>
                    Aplicar Filtros
                </button>
            </div>
        </>
    );
};

export default FiltroFechaUI;